import { useState } from 'react';
import { SELF_BUBBLES, SELF_STANDS } from '../../lib/map3d/pinDraft';
import { setSelfLook, useSelfLook } from '../../lib/map/faceStyle';

const ARROWS = { a: 'Old board', f: 'Board from your feet', d: 'On the ground (pick)' };
const ON_KEY = 'prii.dev.selfpick';

/**
 * Dev only (`?selfpick=1`, remembered; `?selfpick=0` hides it): flip how you look on the map and Find while you move
 * around - the bubble, its stand and the guide arrow's rule on a hill - for Sam's Stage 6 pick.
 */
export default function SelfLookPicker() {
  const [on] = useState(() => {
    if (!import.meta.env.DEV) return false;
    try {
      const q = new URLSearchParams(window.location.search).get('selfpick');
      if (q === '1') window.localStorage.setItem(ON_KEY, '1');
      if (q === '0') window.localStorage.removeItem(ON_KEY);
      return window.localStorage.getItem(ON_KEY) === '1';
    } catch {
      return false;
    }
  });
  if (!on) return null;
  return <Panel />;
}

function Panel() {
  const look = useSelfLook();
  const [open, setOpen] = useState(true);
  const [arrow, setArrow] = useState(() => window.__arrow ?? 'd');
  const bubble = look?.bubble ?? 1,
    stand = look?.stand ?? 'n';
  const pick = (b, s) => setSelfLook(`${b}${s}`);
  const chip = (active) =>
    `rounded-full px-2 py-1 text-[11px] font-semibold ${
      active ? 'bg-[#c89bff] text-[#1b1230]' : 'bg-white/10 text-white'
    }`;
  return (
    <div
      className="fixed left-2 right-2 z-[9999] rounded-2xl border border-[#c89bff]/50 bg-[#1b1230]/90 p-2 text-white backdrop-blur"
      style={{ top: 'calc(env(safe-area-inset-top) + 4px)' }}
    >
      <button
        type="button"
        className="w-full text-left text-[12px] font-bold"
        onClick={() => setOpen(!open)}
      >
        You:{' '}
        {look
          ? `${look.bubble} ${SELF_BUBBLES[look.bubble]} · ${SELF_STANDS[look.stand]}`
          : 'Puck (old)'}
        {' · '}Arrow: {ARROWS[arrow]} {open ? '▴' : '▾'}
      </button>
      {open && (
        <div className="mt-1.5 flex flex-col gap-1.5">
          <div className="flex flex-wrap gap-1">
            <button type="button" className={chip(!look)} onClick={() => setSelfLook('puck')}>
              Puck
            </button>
            {Object.entries(SELF_BUBBLES).map(([k, label]) => (
              <button
                key={k}
                type="button"
                title={label}
                className={chip(look && bubble === Number(k))}
                onClick={() => pick(k, stand)}
              >
                {k}
              </button>
            ))}
          </div>
          <div className="flex flex-wrap gap-1">
            {Object.entries(SELF_STANDS).map(([k, label]) => (
              <button
                key={k}
                type="button"
                className={chip(look && stand === k)}
                onClick={() => pick(bubble, k)}
              >
                {label}
              </button>
            ))}
          </div>
          <div className="flex flex-wrap gap-1">
            {Object.entries(ARROWS).map(([k, label]) => (
              <button
                key={k}
                type="button"
                className={chip(arrow === k)}
                onClick={() => {
                  window.__arrow = k;
                  setArrow(k);
                }}
              >
                Arrow: {label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
